<script>
    import {push, pop, replace} from 'svelte-spa-router'
	import { fade } from 'svelte/transition';
	import Header from './Header.svelte';
	import { springIn } from "svelte-helpers/spring-transitions";
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import { Line } from 'svelte-chartjs'
	import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale } from 'chart.js';

	import Modal, { bind } from 'svelte-simple-modal';
	import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	const modal = writable(null);
	const modal1 = writable(null);

	let charged = Math.random() * 0.0025 + 0.0003;
	charged = 0.0005;
	const SPRING_IN = { stiffness: charged, damping: 0.0008 };
	let a_duration = 40000;
	const animateIn = (node) => {
		const { duration, tickToValue } = springIn(-6, 0, SPRING_IN);
		return {
			duration: ( a_duration ),
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

	let power = tweened(1, {
		duration: 100,
		easing: cubicOut
	});
	let enemy = 0;
	let kicked = false;
	let kick_start = 0;
	let item_display = '';
	let mebot_url;
	let wormhole = false;

	function longpress(node, threshold = 1000) {
	// note — a complete answer would also consider touch events

	const handle_mousedown = () => {
		kick_start = Date.now();

		console.log('started')
		enemy = Math.floor(1 * 1000 + 2000)
		power = tweened(0, {
		    duration: enemy,
		    easing: cubicOut
	    });
		power.set(1);
	
	  const timeout = setTimeout(() => {
		node.dispatchEvent(new CustomEvent('longpress'));
		power.set(0);
		console.log('done')
		item_display = '💨';
		a_duration = 0;
		kick(10)
	  }, threshold);

	  const cancel = () => {
		//clearTimeout(timeout);
		//power.set(0);
		node.removeEventListener('mousemove', cancel);
		node.removeEventListener('mouseup', cancel);
	  };

	  node.addEventListener('mousemove', cancel);
	  node.addEventListener('mouseup', cancel);
	}

	node.addEventListener('mousedown', handle_mousedown);

	return {
	  destroy() {
		node.removeEventListener('mousedown', handle_mousedown);
	  }
	};
  }

	ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale);

	let activity_data = {
	  labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
	  datasets: [
	    {
			label: 'Watts',
			fill: true,
			lineTension: 0.3,
			backgroundColor: 'rgba(255, 255, 255, 1)',
			borderColor: 'hsl(185, 97%, 75%)',
			borderCapStyle: 'butt',
			borderDash: [],
			borderWidth: 2,
			borderDashOffset: 0.0,
			borderJoinStyle: 'round',
			pointRadius: 0,
			data: [50, 50, 50, 50, 50, 50, 45, 50, 50, 22, 50, 50, 23, 90],
		},],
	};

    function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

	function set_section(name) {
        setCookie("section", name, 1)
    }

	function displayTimeflow(rate, str) {
		displayMebotMessage(`
		` + str + ` `, 
		20000, 'Ok');
	}

	async function visitMap() {
		replace('/go/2/map/1_' + h_id);
	}

	const embarkOnJourney = () => {

		const res = fetch(
			"https://api.forever.today/?method=embark_on_journey",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					mebot_id: m_id,
					habitat_id
				}),
			}
		);

		modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
			I'm on the way to <b>` + habitat_name + `</b>!<br><br>

			<table width=240>
				<tr>
					<td align=center>
						<img src='` + mebot_url + `' width=100 height=100 alt='Mebot'>
					</td>
					<td align=center><span style='white-space: nowrap;'>➡️ &nbsp;&nbsp;&nbsp;</span></td>
					<td align=center>
						<img src='` + habitat_img_url + `' width=80 height=80 style='border-radius: 20px;' alt='Habitat'>
					</td>
				</tr>
			</table>

		<br><br>
		</center>`, closeButton: true, action_button: 'See map 🗺️', on_action: visitMap}));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 5000);

	}

	function displayDirections() {

		getHabitatDirections();
		displayMebotMessage(`
		<center>
			<br>
			<b>How to get there?</b>
			<br><br>
		</center>`, 10000, ' 🧭 Get directions 👉', onHowToGetThereAction);
	}

	function displayTags() {

		if (h_tags.length == 0 && h_count > 0) {

			getHabitatDirections();
			displayMebotMessage(`
		<center>
			<br><br>
			🏷️ Tags at this habitat: <b><font color="lightblue">` + h_count + `</font></b>
			<br>` + habitat_tags + `
			<br>
		</center>`, 20000, ' 🧭 How to get there? ', onHowToGetThereAction);

		} else {

		displayMebotMessage(`
		<center>
			<br><br>
			🏷️ Tags at this habitat:
			<br><br>` + habitat_tags + `
			<br><br>
		</center>`, 10000, 'Add tag', onTagAddAction);

		}
	}

	const onTagAddAction = () => {

		console.log('add action')

		hab_tag = '';
		show_add_tag = true;
    };

	const onGetAppAction = () => {

		setCookie("v_h_id", -3, 1)
		replace("/dash/2/1");
	};

	async function embarkNow() {

		await getHabitatDirections();
		onHowToGetThereAction()
	}

	const onHowToGetThereAction = () => {

		if (habitat_meters == 'open_app') {

			let action = null;
			let action_call = 'Okay';
			if (getCookie("is_anon") == 1) {
				action = onGetAppAction;
				action_call = 'Get app 📱';
			}

			displayMebotMessage(`
		<center>
			<br>
			<div class="text-electric" style="font-size: 65px;" >
				<div> 🧭 </div>
			</div>
			<br>
			` + habitat_direction + `
			<br><br>
		</center>`, 10000, action_call, action);

		} else {

			if (embark['steps_away'] > 0) {

				displayMebotMessage(`
		<center>
			<br>
			<div class="text-electric" style="font-size: 65px;" >
				<div> 🧭 </div>
			</div>
			<br>
			<b>` + habitat_name + `</b>  ` +  habitat_meters + ` from you. <br><br><b> ` + habitat_direction + ` </b>
			<br><br>
			` + embark['info'] + `
			<br><br>
		</center>`, 25000, 'Send your Mebot here ➡️', embarkOnJourney);

			} else {

				displayMebotMessage(`
		<center>
			<br>
			<div class="text-electric" style="font-size: 65px;" >
				<div> 🧭 </div>
			</div>
			<br>
			<b>` + habitat_name + `</b>  ` +  habitat_meters + ` from you. <br><br><b> ` + habitat_direction + ` </b>
			<br><br>
			` + embark['info'] + `
			<br><br>
		</center>`, 25000, 'Okay');

			}
		}

    };

	async function hideKeyboard() {
		//field = document.createElement('input');
		//field.setAttribute('type', 'text');

		
		field = document.getElementById('tag_input')
		field.blur();
		field.setAttribute('style', 'display:none;');
		field.inputMode = "none";

		/*
		field.attr('readonly', 'readonly'); // Force keyboard to hide on input field.
		field.attr('disabled', 'true'); // Force keyboard to hide on textarea field.

		setTimeout(function() {
		    element.blur();
		    setTimeout(function() {
	     	   field.setAttribute('style', 'display:none;');
			   console.log('hidden')
		    }, 50);
		}, 50);

		field.blur();
//		field.setAttribute('style', 'display:none;');*/

	}

	async function viewHabitatVisitors() {

		let day = (h_stats.dhvi != '' ? h_stats.dhvi : '-')
		let weekly = (h_stats.whvi != '' ? h_stats.whvi : '-')
		let monthly = (h_stats.mhvi != '' ? h_stats.mhvi : '-')
		let all = (h_stats.hvi != '' ? h_stats.hvi : '-')

		let daily = '';
		if (h_stats.dhvi != '' && h_stats.dhvi != 0) {
			daily = `Visitors today: <b><font color="lightblue">` + h_stats.dhvi + ` </font></b><br>`
		}

		displayMebotMessage(`
		<center>
			<br><br>
			<b>Habitat Visitors</b><br><br>
			` + daily + ` 
			This week: <b><font color="lightblue">` + weekly + ` </font></b><br>
			This month: <b><font color="lightblue">` + monthly + ` </font></b><br>
			All time: <b><font color="lightblue">` + all + `</font></b><br>
			<br><br><br>
		</center>`, 10000);
	}

	async function viewHabitatDetails() {

		if (dash_token != '1') {
			setCookie("v_h_id", habitat_id, 1)
			//replace("/dash/" + dash_token + "/1");
			replace("/dash/2/1");
		}

		return;
	}

	async function kick(direction) {
	
		const res = await fetch(
			"https://api.forever.today/?method=item_action",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					habitat_id,
					mebot_id: m_id,
					item_id: item.id,
					action: direction
				}),
			}
		);

		item_to_find = '';

		const json = await res.json();

		action_habitat_name = json.data.action.habitat_name;
		action_file_id = json.data.action.file_id;
		action_img_url = json.data.action.url;

		if (action_habitat_name != '') {
			show_action_performed = true;
		}
		//show_item_action = false;
	}

	async function addTag() {

		field = document.getElementById('tag_input')
		field.focus();
		field.inputMode = "none";

		setTimeout(function() {
			field.blur();
	     	field.setAttribute('style', 'display:none;');
			console.log('hidden')
		}, 50);

		console.log('add action: ' + hab_tag)

		const res = await fetch(
			"https://api.forever.today/?method=add_habitat_tag",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					habitat_id,
					mebot_id: m_id,
					tag: hab_tag
				}),
			}
		);

		await getHabitat(h_id);
		show_add_tag = false;
	}

	function displayStructures() {

		let habitat_s = '<font size=6> ';
		for (const runner of h_sts_tmp) {
			habitat_s = habitat_s + runner.em + ' '
		}
		habitat_s = habitat_s + ' </font>'

		//There are ` + h_sts_tmp.length + ` structures at this habitat

		if (is_mayor == 1) {

			displayMebotMessage(`
		<center>
			<br><br>
			Structures at this habitat
			<br><br>` + habitat_s + `
			<br><br><br>
		</center>`, 10000, ' ➕ Build more ', viewHabitatDetails);

		} else {

			displayMebotMessage(`
		<center>
			<br><br>
			Structures at this habitat
			<br><br>` + habitat_s + `
			<br><br><br>
		</center>`, 10000);

		}
	}

	function viewPlaces() {

		if (places_n >= 0) {
			push('/habitat_places/' + dash_token_link + '/' + h_id);
		}
	}

	function viewGems() {

		if (hidden_gems_n > 0) {

			getHabitatDirections();

			let chest = '';
			if (chest_url != '') {
				chest = `<img style="box-shadow: 0 5px 15px hsl(185, 97%, 75%); border-radius: 20px;" src="` + chest_url + `" width=160px height=160px alt="treasure chest">
			<br><br><br>`;
			}

			displayMebotMessage(`
		<center>
			<br><br>
			` + chest + `
			There's a chest 📦  with gems 💎 artifacts & Mebot eggs 🥚 located at this habitat.<br><br>

			But it's locked... 🔒 <br>
			Help unlock it!<br><br>
			🔃 1/10  &nbsp;&nbsp;&nbsp; 💜 2/10<br><br>
		</center>`, 15000, ' How? ', onHowToGetThereAction);

			return;
			displayMebotMessage(`
		<center>
			<br><br>
			` + chest + `
			There's a chest 📦  with gems 💎 artifacts & Mebot eggs 🥚 located at this habitat.<br><br>

			Visit <b>` + habitat_name + `</b> to unearth it   ⛏ 🔒 👀
			<br><br>
		</center>`, 15000, ' How to get there? ', onHowToGetThereAction);

			displayMebotMessage(`
		<center>
			<br><br>
			<b>There are (` + hidden_gems_n + `) hidden gems and artifacts  💎 🔒 ⛏  </b> here!<br><br>

			Visit <b>` + habitat_name + `</b> to uncover them 👀 and claim them!
			<br><br>
		</center>`, 10000, ' How to get there? ', onHowToGetThereAction);

		}
	}

	function displayMayor() {

		let owner_msg = '';

		if (mayor_badges != '' && mayor_badges != null) {
			owner_msg = owner_msg + mayor_badges + '<br>' 
		}

		if (is_mayor) {
			owner_msg = owner_msg + '<br> You are the owner and mayor. <br>';
		} else {

			//send to stats page
			if (mayor_id != null) {
				push('/stats/' + dash_token_link + '/' + mayor_id + '/' + mayor_id);
				return;
			}
		}

		displayMebotMessage(`
		<center>
			<br><br>
		 👑&nbsp; Mayor of ` + habitat_name + `</b><br><br>

			<img src='` + mayor_mebot_img_url + `' width=100 height=100 alt=''><br>

			` + owner_msg + `

			<br><br>
		</center>`, 5000, 'View Stats 📈', viewStats);
	}

	function viewStats() {
		push('/stats/' + dash_token_link + '/' + m_id + '/' + mayor_id);
	}

	function showSparksFound(n_sparks, base) {

		displayMebotMessage(`
		<center>
			<br><br>
		<b>Wow! 🌟 </b><br><br>

		You discovered  <b>` + base + `</b><br><br>
		And found ` + n_sparks + ` sparks there!<br> ✨✨✨<br>
		<br><br>
		</center>`, 10000, 'Nice!');
	}

	function showFound(item, image, name, action, base, avp, energy) {

		let action_msg = 'Nice!';

		if (item_found.t_id == 2) {
			item_display = item_found.em;
			show_item_action = true;
			action_msg = item_found.av + ' it... ' + item.em;

			power.set(0.1);

			avp = 'Found';
		}
	
		let emo = '🌟';
		if (item_found.em != '') {
			emo = item_found.em;
		}

		displayMebotMessage(`
		<center>
			<br><br>
			` + emo + `  ` + avp + ` ` + name + `<br> at <b>` + base + `</b> <br><br>

			` + image + `
		<br>
		` + action + `
		` + energy + `
		<br><br>

		</center>`, 20000, action_msg);

		if (item_found.t_id == 2) {
			show_item_action = true;
		}
	}

	function showToFind() {

		if (item_found.t_id == 2) {
			//showFound(item_found.em, item_found.n, item_found.a, habitat_name);
			show_item_action = true;
			return;
		}

		getHabitatDirections();

		displayMebotMessage(`
		<center>
			<br><br>
			🌟 There's a <b>` + item.n + `</b> 📍<br>
			at <b>` + habitat_name + `</b><br><br> 

			` + item.item_image + `
		<br>

		` + item.d + `<br><br>

		</center>`, 10000, 'How to get there?', onHowToGetThereAction);
	}


	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = false
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

	//set_section('health_stats');

    // The params prop contains values matched from the URL
    export let params = {}

    let dash_token = params.t
    let h_id = params.h_id;
	let owner_class = null;
    let m_id = params.m_id;
	let is_chest = params.is_chest;

    //if (m_id == '') {
	//console.log('GOT m_id from cookie:' + getCookie('m_id'));
	m_id = getCookie('m_id');
    if (!mebot_url) {
        mebot_url = getCookie('mebot_img_url');
    }

	//}
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
		if (dash_token == '' || dash_token == null) {
			dash_token = '1';
		}
	}

	if (dash_token == '1') {
		setCookie('source_habitat', h_id, 7)
	}

	let dash_token_link = dash_token;
	if (dash_token_link != '1') {
		dash_token_link = '2'
	}

    let result = null
    let habitat_img_url = null;
	let habitat_name = null;
	let guild = null;
	let social_link = null;
	let social_msg = null;
	let copied = false;

	let habitat_id = 0;
	let h_stats = null;
	let activity_n = 0;
	let h_sts = [];
	let h_sts_tmp = [];
	let h_tags = [];
	let habitat_tags = '';
	let mayor_mebot_img_url = null;
	let mayor_id = null;
	let mayor_badges = '';
	let is_mayor = 0;
	let is_settled = 0;
	let h_settlers_count = 0;
	let is_own = 0;
	let show_add_tag = false;
	let show_item_action = false;
	let show_action_performed = false;
	let hab_tag = '';
	let h_count = 0;
	let hidden_gems_n = 0;
	let places_n = -1;
	let chest_url = '';
	let is_fav_hab = 0;
	let has_visited = 0;

	let action_habitat_name = '';
	let action_file_id = '';
	let action_img_url = ''

	let habitat_meters = '';
	let habitat_direction = '';
	let item_to_find = '';
	let item = null;
	let item_found = null;
	let embark = [];
	embark['em'] = '';
	embark['info'] = '';
	embark['steps_away'] = 0;

	let frame;
	let sparklers_animation = false;
	let sparklers_found = false;
	let sparklers_chars = ['✨'];
	let sparklers = new Array(100).fill().map((_, i) => {
		return {
			character: sparklers_chars[i % sparklers_chars.length],
			x: Math.random() * 100,
			y: -20 - Math.random() * 100,
			r: 0.1 + Math.random() * 1.2
		};
	}).sort((a, b) => a.r - b.r);

	var field;

    let mebot_i = null;
    let watts_score = '';
    let steps = '';
    let explorer = '';
    let social = '';
    let hrv = '';
    let m1 = null;
    let m2 = null;
    let mebot = [];
	let liking = false;
	let liked = false;
	let waving = false;
	let battling = false;
	let show_close = true;
	let timeout_id;
	let sparkles_time = 3500;

	function doNothing() {

		let current_section = getCookie("section");

		if (dash_token != '1' || current_section == 'leaderboard') {
			pop()
		}

		console.log('do nothing');
		return;
	}

	function enterWorld() {

		push('/world/2/' + h_id);
	}

	function enterMap42() {

		push('/map42/2/' + h_id);
	}

	function copyToClipboard(textToCopy) {
		// navigator clipboard api needs a secure context (https)
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard api method'
			return navigator.clipboard.writeText(textToCopy);
		} else {
			// text area method
			let textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			// make the textarea out of viewport
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				// here the magic happens
				document.execCommand('copy') ? res() : rej();
				textArea.remove();
			});
		}
	}

	function copySuccess() {
		//copyError();
		//return;
		copied = true;
		if (copied == true) {
			setTimeout(
				function() {
					copied = false;
					showLinkCopied()
				},
			300
			);
		}
	}

	function copyError() {

		let tweet_msg = social_msg + social_link + ' @ForeveToday';

		displayMebotMessage(`
		<center>
		<br><br>
		🔗 Habitat link:<br><br>
		<input value="` + social_link + `"></input>
		<br><br><br>

		🐦 Share tweet or post on Threads:<br><br>
		<textarea rows="4" cols="30">` + tweet_msg + `</textarea >
		<br><br><br>

		`, 100000);
	}

	function copyHabitatLink() {
		var copyText = document.getElementById("social_link");
		//alert("Copied the text: " + copyText.value);

		copyToClipboard(copyText.value)
			.then(() => copySuccess() )
			.catch(() => copyError() );

	}

	function showLinkCopied() {

		let tweet_msg = social_msg + social_link + ' @ForeveToday';

		displayMebotMessage(`
		<center>
		<br><br><br>
		Habitat link 🔗<br> has been copied to your clipboard.<br><br>

		<button> Copy </button>

		<br><br>
		🐦 Share tweet or post on Threads:<br><br>
		<textarea rows="4" cols="30">` + tweet_msg + `</textarea >
		<br><br>
		`, 100000);
	}

	function showHabitatFavs() {
		let likes = 'likes';
		if (h_stats.like_n == 1) {
			likes = 'like';
		}

		displayMebotMessage(`
		<center>
		<br><br><br>
		 Your habitat has <font color="lightblue"> ` + h_stats.like_n + `</font><br> ` + likes + `.
		<br><br><br>
		`, 10000);
	}

	function sparklers_loop() {
		if (sparklers_animation) {
			frame = requestAnimationFrame(sparklers_loop);
		}

		sparklers = sparklers.map(emoji => {
			emoji.y += 0.7 * emoji.r;
			emoji.x += 0.7 * emoji.r;
			if (emoji.y > 120) emoji.y = -20;
			if (emoji.x > 120) emoji.x = -20;
			return emoji;
		});
	}

	async function getHabitat(h_id) {

		h_tags = [];
		mayor_mebot_img_url = '';

		const res = await fetch(
			"https://api.forever.today/?method=get_habitat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					mebot_id: m_id,
					file_id: h_id
				}),
			}
		);

		const json = await res.json();
        habitat_img_url = json.data.habitat.url;
		habitat_name = json.data.habitat.name;
		guild = json.data.habitat.guild;
		habitat_id = json.data.habitat.id;
		mayor_mebot_img_url = json.data.habitat.mebot_img_url;
		mayor_id = json.data.habitat.mayor_id;
		mayor_badges = json.data.habitat.mayor_badges;
		social_link = json.data.habitat.social_link;
		social_msg = json.data.habitat.social_msg;

		is_mayor = json.data.habitat.is_mayor;
		is_fav_hab = json.data.habitat.is_fav;
		h_settlers_count = json.data.habitat.h_settlers_n;
		is_settled = json.data.habitat.is_settled;
		is_own = json.data.habitat.is_own;
		h_count = json.data.habitat.h_count;
		has_visited = json.data.habitat.has_visited;
		hidden_gems_n = json.data.habitat.hidden_gems_n;
		places_n = json.data.habitat.places_n;
		chest_url = json.data.habitat.chest_url;

		h_stats = json.data.habitat.stats;
		activity_data.datasets[0].data = json.data.habitat.activity;
		activity_n = json.data.habitat.activity_n;
		item = json.data.habitat.item_to_find;
		item_to_find = json.data.habitat.item_to_find.em;
		item_found = json.data.habitat.item_found;
	
		embark = json.data.habitat.embark;
	
		let runners = json.data.habitat.structures;
		h_sts_tmp = [];
		for (const runner of runners) {
			h_sts_tmp.push({
				id: runner.id,
				name: runner.name,
				em: runner.em,
				class: runner.em
			});
		}
		h_sts = h_sts_tmp.slice(0,1)

		h_tags = json.data.habitat.tags;
		habitat_tags = '';
		for (const t of h_tags) {
			habitat_tags = habitat_tags + '&nbsp;  ' + t + '<br>'
		}

		if (h_tags.length == 0 && h_count > 0) {
			habitat_tags = '<br><i>There are tags hidden at this habitat.</i><br><br> Visit <b><font color="lightblue">' + habitat_name + '</font></b> in real life to discover them.<br>'
		}

		if (item_found.em != '' && item_found.t_id == 2) {
			sparkles_time = 0;
		}

		//set emojis to rain
		if (item_found.em != '' && item_found.t_id != 10) {
			sparklers_chars = [item_found.em];
			sparklers = new Array(100).fill().map((_, i) => {
				return {
					character: sparklers_chars[i % sparklers_chars.length],
					x: Math.random() * 100,
					y: -20 - Math.random() * 100,
					r: 0.1 + Math.random() * 1.2
				};
			}).sort((a, b) => a.r - b.r);
		}

		if (item_to_find != '' && item.asi == 1) {
			//showToFind();
		}

		if (json.data.habitat.item_found.em != '') {
			showFound(json.data.habitat.item_found, json.data.habitat.item_found.item_image, json.data.habitat.item_found.n, json.data.habitat.item_found.a, habitat_name, json.data.habitat.item_found.avp, json.data.habitat.item_found.energy);
		}

		if (json.data.habitat.item_found.em != '' && item_found.t_id != 10) {
			//don't do sparkles if found an artifact
			sparklers_animation = true;
			sparklers_loop();
			setTimeout(function(){
				sparklers_animation = false;
			}, sparkles_time);
		} else if (json.data.habitat.disc_sparks_n > 0 && item_found.t_id != 10) {
			//if found artifact (t_id = 10) don't do spark shower
			showSparksFound(json.data.habitat.disc_sparks_n, habitat_name);
			sparklers_animation = true;
			sparklers_loop();
			setTimeout(function(){
				sparklers_animation = false;
			}, 8500);
		}

		if (is_chest == 1 && hidden_gems_n > 0) {
			viewGems();
		}

		if (hidden_gems_n > 0) {
			wormhole = true;
		}
	}

	async function getHabitatDirections() {
		const res = await fetch(
			"https://api.forever.today/?method=get_habitat_direction",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					habitat_id
				}),
			}
		);

		const json = await res.json();
        habitat_meters = json.data.habitat.meters;
		habitat_direction = json.data.habitat.direction;
	}

	async function favHabitat(habitat_id) {

		liking = true;
		setTimeout(function() {
			if (is_fav_hab != true) {
				h_stats.like_n = h_stats.like_n + 1;
			}
			liking = false;
			is_fav_hab = true;
		}, 700);

		const res = await fetch(
			"https://api.forever.today/?method=fav_habitat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id,
					habitat_id
				}),
			}
		);
	}

	function show_badge_n(n) {

		if (isNaN(n) || n == 0  || n == '') {
			return '';
		} else {
			return n;
		}
	}

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}

	async function visitActionHab() {
		push("/map/2/1");
		await sleep(300);

		push('/habitat/2/' + action_file_id);

	}

	function onKeyDown(e) {
		console.log(e.keyCode)
	}
    getHabitat(h_id)

	async function clickWormhole() {
		console.log('clicked that hole')
		wormhole = !wormhole;
	}

	/*
	var monitor = setInterval(function(){
		var elem = document.activeElement;
		if (elem && elem.tagName == 'IFRAME') {
			clearInterval(monitor);
			clickWormhole();
		}
	}, 100);*/

</script>

{#if sparklers_animation }
	<div transition:fade|local={{duration: 300}}>
	{#each sparklers as c}
		<div class="sparks_found" style="z-index: 100; left: {c.x}%; top: {c.y}%; transform: scale({c.r})">{c.character}</div>
	{/each}
	</div>
{/if}
<Header
    header_mebot_id = { m_id }
	header_dash_token = { dash_token }
/>



<center>
	{#if habitat_img_url}
	<table width=300px border=0>
		{#if show_add_tag == false && show_item_action == false }
		<tr>
			<td width="5px"><div class="text-glow" style="white-space: nowrap; font-size: 20px;">&nbsp;&nbsp;&nbsp;	</td>
			<td width=290px>
				<div style="user-select: none;" >
					<!--<div
						href="/#/move/{dash_token}/{m_id}"
						style="user-select: none;"
					>-->

						<div style="position: relative;" on:click={() => doNothing}>
						{#if false }

							<div style="position: relative; width: 270px; height: 270px; ">
								{#if wormhole }

								<div class="main1-square">
									<div style="width: 270px; height: 270px; overflow: hidden" on:click={ () => clickWormhole() }>
										<iframe title="iframe" src="https://mebots.xyz/exper/wormhole/" width="270" height="270"
											scrolling="yes" style="width: 270px; height: 270px; border:none;"
											allowtransparency="true">
											Mebots content
										</iframe>
									</div>
								</div>

								{/if}
							</div>

						{:else }
						<img style="user-select: none;"
							on:click={ doNothing }
							src={habitat_img_url}
							width="270px"
							height="270px"
							alt="Habitat"
							class="no_tap_zoom habitat_lg hab_lg_activ"
						/>
						{/if}

						{#if false && wormhole }
						<!--
						<span class="map42_menu_btn" on:click={() => enterMap42() }>
							&nbsp; <span class="text-electric"> 🌐 </span> &nbsp;
						</span>

						<span class="world42_menu_btn" on:click={() => enterWorld() }>
							&nbsp; <span class="text-electric"> 🌏 </span> &nbsp;
						</span>-->
						{/if}

						</div>

					<!--</div>-->
				</div>
			</td>
			<td width="5px"><div class="text-glow" style="white-space: nowrap; font-size: 20px;"></td>
		</tr>
		{/if}
		<tr height="40px">
			<td width=50px align=center>
				{#if show_add_tag == true || show_item_action == true }
					<span class="text-electric" style="white-space: nowrap; font-size: 14px;" on:click={ () => { show_add_tag = false; show_item_action = false; }}>&nbsp;&nbsp; ✖️ &nbsp; </span>
				{/if}
				&nbsp;
			</td>
			<td align=center>
				<table border=0 width=200px cellspacing=0 cellpadding=0><tr>
					<td align=center><span class="text-electric" style="font-size: 14px; margin-top: 12px; margin-bottom: 6px;">{ habitat_name }</span></td>
					<!--<td width=10px align=right on:click={() => showShareHabitat() }><span>🔗&nbsp;</span></td>-->
				</tr></table>
			</td>
			<td width=50px align=right  on:click={ copyHabitatLink }>
				<div class="text-electric" >
					<input size="22" type="hidden" id="social_link" bind:value={social_link} >
					<span class="tooltip" style="font-size: 10px; white-space: nowrap;" class:copy-pulsing={ copied }> <span>&nbsp;🔗&nbsp;</span> </span>
				</div>
			</td>
		</tr>
	</table>
	{#if show_add_tag == true }
	<table width=300px border=0>
	<tr>
		<td align=center>
			<br>
<!--			<span class="text-electric">
				🏷️ Your tags:<br><br>
				<br><br>-->
			<span class="text-electric">
				➕  Add tag:<br><br>
				<input id="tag_input" bind:value={hab_tag} class="menu_btn_home menu_btn_home_inactive" type="type" maxlength="100" size="26">
			<br><br>
			<button class="menu_btn_home" type="submit">
				<span class="text-electric" on:click={ () => addTag() }>&nbsp; Add tag &nbsp;</span>
			</button>
			</span>
		</td>
	</tr>
	</table>
	{:else if show_item_action == true }
	<table width=300px border=0>
		<tr>
			<td align=center valign=top>
				<span class="text-electric">

				<img src={habitat_img_url} width="50px" alt="Land42" class="habitat_lg"/>
				<br><br>

				{#if show_action_performed == true }
					<br>
									<!--You found:<br><br>-->
									<div class="text-electric" style="font-size: 35px;" >
									{ item_found.em } 💨
									</div>
					<br>
					Nice! You've { item_found.avp } it to 👇<br><br>
					<div on:click={ visitActionHab }>
					<img 
					src={action_img_url}
					width="60px"
					alt="Land42"
					class="habitat_lg"
					/><br><br>
					{ action_habitat_name }
					</div>
					<br><br>
				{:else }

				{@html item_found.a }
				<br><br>

				<table width=250px>
					<tr><td></td><td align=center>
						<button class="menu_btn_home_1" type="submit">
							<span class="text-electric" use:longpress on:longpress="{e => kicked = true}" >&nbsp; ⬆️ &nbsp; <br> &nbsp; { item_found.av } &nbsp;</span>
						</button>
					</td><td></td></tr>
					<tr><td align=right>
						<button class="menu_btn_home_1" type="submit">
							<span class="text-electric" on:click={ () => kick(4) }>&nbsp; ⬅️ &nbsp; <br> &nbsp; { item_found.av } &nbsp;</span>
						</button>
					</td><td align=center valign=middle>
						<div in:animateIn  class="text-electric" style="font-size: 65px;" >
							{ item_display }
						</div>
						{#if ($power > 0) }
						<div class="outer">
							<div class="progress_inner" style="width: {$power * 100}%; margin-top: 5px;" ></div>
						</div>
						{/if}
					</td><td>
						<button class="menu_btn_home_1" type="submit">
							<span class="text-electric" on:click={ () => kick(3) }>&nbsp; ➡️ &nbsp; <br> &nbsp; { item_found.av } &nbsp;</span>
						</button>
					</td></tr>
					<tr><td></td><td align=center>
						<button class="menu_btn_home_1" type="submit">
							<span class="text-electric" on:click={ () => kick(2) }>&nbsp; { item_found.av } &nbsp; <br> &nbsp; ⬇️ &nbsp;</span>
						</button>
					</td><td></td></tr>

					<tr>
						<td colspan=3 align=center>
						</td>
					</tr>
				</table>
				{#if (item_found.srth == 1) }
				<br>
				<button class="menu_btn_home_1" type="submit">
					<span class="text-electric" on:click={ () => kick(10) }>
						{item_found.em} Bring  it to your<br>&nbsp; current location 📍
						&nbsp;</span>
				</button>
				{/if}

				{/if}
			</td>
		</tr>
	</table>
	{:else }
	<table width=300px cellpadding=0 cellspacing=1 border=0>
		<!--
		{#if mebot_id == 76 || mebot_id == 87 || mebot_id == 250}
		<tr height=26px>
			<td width=55px>&nbsp;</td>
			<td align=right class="shadow_bg" width=180px colspan=2> <div class="vitals2 text-electric" style="white-space: nowrap;">&nbsp; <span style="position: relative;">🏆<span class="artifact__badge"> 7 </span></span>&nbsp;&nbsp; 🥈 <span style="position: relative;">🥊<span class="artifact__badge"> 2 </span></span>&nbsp;&nbsp; 🎧 〇 🎒 🛴 🛶 &nbsp;</div></td>
			<td width=60px>&nbsp;</td>
		</tr>
		{/if}-->
		<tr height=28px>
			<td width=55px align="center" valign="middle">
				<div style="margin-bottom: 0px;">
				{#if mayor_mebot_img_url != null }
				<img src={mayor_mebot_img_url} width="24px" height=24px in:fade|local={{duration: 300}} style="margin-top: 00px;" alt="Mayor mebot" on:click={ displayMayor }/>
				{/if}
				</div>
			</td>
			<td align=left class="shadow_bg" width=100px> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={ () => viewHabitatDetails() }>&nbsp;⚡ &nbsp;Activity </div></td>
			<td align=right class="shadow_bg" width=80px> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={ () => viewHabitatDetails() }> <b>{ (activity_n > 0 ? activity_n : '-') }</b> &nbsp;</div> </td>
			<!--<td width=60px style="position: relative;" valign=middle align=left rowspan=2 on:click={ () => viewGems() }>
				{#if hidden_gems_n > 0 }
					&nbsp;&nbsp; 📦 &nbsp;&nbsp;
					<span class="habitat__badge_gem">{ '1' }</span>
				{/if}
			</td>-->
			<td width=60px style="position: relative;" valign=middle align=center rowspan=2 on:click={ () => viewPlaces() }>
				{#if places_n >= 0 }
					<span class="vitals2 text-glow" style="white-space: nowrap; font-size: 28px;">  🟧  </span>
				{/if}
				{#if places_n > 0 && places_n < 10}
					<span class="habitat__badge_se2_digit">{ places_n }</span>
				{/if}
				{#if places_n >= 10 }
					<span class="habitat__badge_se2">{ places_n }</span>
				{/if}
			</td>
		</tr>
		<tr height=28px>
			<td width=55px>
				<div class="vitals2 text-glow" style="font-size: 10px; nowrap;" on:click={() => displayTimeflow(h_stats.timeflow, h_stats.timeflow_str) }>
					&nbsp; 🌎 <span style="font-size: 8px;">x</span> { h_stats.timeflow }
				</div>
			</td>
			<td align=left class="shadow_bg" width=100px> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={ () => viewHabitatDetails() }>&nbsp;🏡 &nbsp;Settlers</div></td>
			<td align=right class="shadow_bg" width=80px> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={ () => viewHabitatDetails() }> <b>{ (h_stats.hse != '' ? h_stats.hse : '-') } </b> &nbsp;</div> </td>
		</tr>
		<tr height=28px>
			<td width=55px align="center" valign="middle">
				{#if (h_sts.length == 0 && is_mayor == 1) }
					<span on:click={ viewHabitatDetails }>➕</span>
				{:else}
					<span on:click={ displayStructures }>
					{#each h_sts as structure, i}
					<div style="margin-bottom: 0px;"> { structure.em } </div>
					{/each}
					</span>
				{/if}
			</td>
			<td align=left class="shadow_bg" width=100px> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={ () => viewHabitatDetails() }	>&nbsp;🏃‍♂️ &nbsp;Visitors</div></td>
			<td align=right class="shadow_bg" width=80px> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={ () => viewHabitatVisitors() }>  { (h_stats.whvi != '' ? h_stats.whvi : '-') }  <span style="color:aqua; font-size: 8px;">&nbsp;all:&nbsp;</span><b>{ (h_stats.hvi != '' ? h_stats.hvi : '-') }</b> &nbsp;</div> </td>
			<td width=60px align=center valign=top>
				<span style="margin-bottom: 0px; position: relative;">
					{#if is_mayor == 0 && mayor_mebot_img_url != null }
					<span class="controls" class:like-pulsing={ liking } in:fade|local={{duration: 300}} on:click={ favHabitat(habitat_id) }>
						{#if (is_fav_hab == 1) }
							💛
						{:else}
							🤍
						{/if}
					</span>
					{:else}
					<span class="controls" on:click={ showHabitatFavs(habitat_id) }>
						🤍
					</span>
					{/if}
					<span class="text-electric" style="font-size: 10px;"> {@html (h_stats.like_n != 0 ? h_stats.like_n :  '&nbsp;&nbsp;') }
						&nbsp;&nbsp;
					</span>
				</span>
			</td>
		</tr>
		<tr height=10px>
			<td width=55px align="center" valign="middle">
				<span class="text-electric-white1"  style="font-size: 16px;" on:click={ visitMap }> 🗺️ </span>
			</td>
			<td colspan=2 align=center class="shadow_bg" on:click={ () => viewHabitatDetails() }>
				<div style="margin-top: 8px; margin-bottom: 8px;">
				<Line data={activity_data} height={20} width={175} options={
					{
						responsive: false,
						maintainAspectRatio: false,
						plugins: { legend: false, tooltip: false },
						scales: { x: {display: false, grid: {display: false}}, y: {display: false, max: 102, grid: {display: false}} }
					}
				}
				/>
				</div>
			</td>
			<td width=60px>
				{#if h_tags.length > 0 || is_mayor == 1 || h_count > 0 || has_visited == 1}
				<div style="margin-top: 5px; position: relative;" on:click={ displayTags }>
					&nbsp;&nbsp; 🏷️
					{#if h_count > 0 }
					<span class="tag__badge">{ h_count }</span>
					{/if}
				</div>
				{:else}
				<div style="margin-top: 5px; position: relative;">
					&nbsp;&nbsp;
				</div>
				{/if}
			</td>
		</tr>

		<tr height=10px>
			<td width=55px align="center" valign="middle">
				{#if embark['em'] != '' }
				<span class="text-electric-white"  style="font-size: 16px;" on:click={ embarkNow }>{@html embark['em'] } </span>
				{/if}
			</td>
			<td colspan=2 align=center>
				<span class="text-electric-white" style="font-size: 14px; margin-top: 12px; margin-bottom: 6px;">{@html guild }</span>
			</td>
			<td width=60px align=center valign="middle">
				{#if item_to_find != '' }
				<span class="text-electric-white"  style="font-size: 16px;" on:click={ showToFind }>{@html item_to_find } &nbsp;</span>
				{/if}
			</td>
		</tr>

	</table>
	{/if}
	{:else}
    <div class="snake_row">
    </div>
	{/if}

	<div class="small_row">
	</div>

</center>

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<Modal
        show={$modal1}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<style>

	.main1-square {
		position: absolute;
		margin-left: auto;
		margin-right: auto;
		display: inline;
		border-radius: 20px;
		background-color: #051420f5;
		height: 270px;
		width: 270px;
		overflow-x: hidden;
		overflow-y: auto;
		text-align: left;
		padding: 0px;
		overscroll-behavior: auto;
		border: none;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		z-index: 10000;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}

	.main1-square::-webkit-scrollbar {
		display: none;
	}

	.copy-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.3s;
	}
	.text-electric {
        font-size: 14px;
		text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
			0 0 14px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}
	.text-electric-white {
        font-size: 14px;
		text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
			0 0 14px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(0, 0%, 100%);
	}
	.shadow_bg {
		background:#7f7f7f;
		background:rgba(0,0,0,0.15);
		border-radius: 6px;
	}
	.snake_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		justify-content: center;
		margin-bottom: 10px;
	}
	.small_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		margin-bottom: 10px;
		margin-left: 40px;
		margin-right: 30px;
	}

	img {
		max-height: 90%;
	}

    .habitat_lg {
        border-radius: 20px;
        box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
    }
	.hab_lg_active {
		box-shadow: 0 5px 15px rgb(231, 247, 255);
    }

	.text-glow {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: white;
	}

	.vitals2 {
		color: white;
		font-size: 14px;
	}

	.no_tap_zoom {
		touch-action: manipulation;
	}

	.habitat__badge_gem {
		background-color: #55f6ff;
		border-radius: 5px;
		border: 0px solid white;
		color: black;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute;
		top: 17px;
		left: 28px;
		z-index: 1000;
	}

	.habitat__badge_se2_digit {
		background-color: rgba(0, 69, 206, 0.459);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgba(0, 132, 255, 0.764), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 12px;

		position: absolute;
		top: 28px;
		left: 32px;
	}
	.habitat__badge_se2 {
		background-color: rgba(0, 69, 206, 0.459);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgba(0, 132, 255, 0.764), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 12px;

		position: absolute;
		top: 28px;
		left: 28px;
	}

	.tag__badge {
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 8px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -4;
		right: 1;
	}

	.menu_btn_home {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #d1f5f88e;
		color: rgba(255, 255, 255, 1);
		box-shadow: 0 5px 15px rgba(211, 214, 215, 0.673);
	}
	.menu_btn_home_1 {
		border-radius: 8px;
		border: 1px solid rgb(83, 83, 83);
		background-color: rgba(0, 139, 203, 0.709);
		color: rgba(255, 255, 255, 1);
		box-shadow: 0 5px 15px rgba(211, 214, 215, 0.673);
	}
	.menu_btn_home_inactive {
		background-color: #20202025;
	}
	.menu_btn_home_invisible {
		border: 0px;
		background-color: #20202025;
	}

	.world42_menu_btn {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		color: rgba(255, 255, 255, 1);
		padding: 6px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
		z-index: 200;
		font-size: 14px;
		background-color: #018779;
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 200;
	}

	.map42_menu_btn {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		color: rgba(255, 255, 255, 1);
		padding: 6px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
		z-index: 200;
		font-size: 14px;
		background-color: #018779;
		position: absolute;
		top: 10px;
		right: 60px;
		z-index: 200;
	}

	.controls {
		font-size: 12px;
		margin-bottom: 0px;
	}

	.like-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.5s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.sparks_found {
		position: absolute;
		font-size: 5vw;
		user-select: none;
	}

	.progress_inner, .outer {
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner {
		background-color: #725cd8;
		display: block;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	}
</style>